import { render, staticRenderFns } from "./navDrawerForCollegeUserPanel.vue?vue&type=template&id=b906e288&"
import script from "./navDrawerForCollegeUserPanel.vue?vue&type=script&lang=js&"
export * from "./navDrawerForCollegeUserPanel.vue?vue&type=script&lang=js&"
import style0 from "./navDrawerForCollegeUserPanel.vue?vue&type=style&index=0&id=b906e288&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports